import { render, staticRenderFns } from "./studentRegistration.vue?vue&type=template&id=b335967e&scoped=true&"
import script from "./studentRegistration.vue?vue&type=script&lang=js&"
export * from "./studentRegistration.vue?vue&type=script&lang=js&"
import style0 from "./studentRegistration.vue?vue&type=style&index=0&lang=css&"
import style1 from "./studentRegistration.vue?vue&type=style&index=1&id=b335967e&scoped=true&lang=css&"
import style2 from "./studentRegistration.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b335967e",
  null
  
)

export default component.exports